'use strict';

function MapRoutes ($stateProvider, UtilsProvider) {

  var latlngPattern = UtilsProvider.Url.getLocationPattern();

  // $stateProvider
  // .state('map', {
  //   url: '',
  //   parent: 'dash',
  //   abstract: true,
  //   views: {
  //     'map@dash': {
  //       controller: 'MapController',
  //       controllerAs: 'vm',
  //       templateUrl: 'dash/map/map.tpl.html',
  //     }
  //   }
  // })
  // .state('map.location', {
  //   url: '/@{location:' + latlngPattern + '}',
  //   resolve: {
  //     locate: ['$stateParams', 'MapStore', locate]
  //   }
  // });

  //////////////////////////////////////////////////////////////////////////////
  // Helpers
  //////////////////////////////////////////////////////////////////////////////

  // function locate ($stateParams, MapStore) {
  //   return MapStore.seedFromRoute($stateParams);
  // }
}

MapRoutes.$inject = ['$stateProvider', 'UtilsProvider'];
module.exports = MapRoutes;


// WEBPACK FOOTER //
// ./src/app/dash/map/MapRoutes.js